/**
 * @prettier
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './DetailColorPicker.less';

const type = 'color';

const DetailColorPicker = ({ colors, activeColor, onSelect }) => (
  <div className="product-color-picker">
    {colors.map(({ label, value }) => (
      <span
        key={value}
        className={cx('product-color-picker__wrapper', {
          'product-color-picker__wrapper--active': activeColor === value,
        })}
        onClick={() => onSelect({ type, label, value })}
      >
        <span className="product-color-picker__circle-back" />
        <span className="product-color-picker__circle-front" style={{ background: `#${value}` }} />
      </span>
    ))}
  </div>
);

DetailColorPicker.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  activeColor: PropTypes.string,
  onSelect: PropTypes.func,
};

export default DetailColorPicker;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/DetailColorPicker/DetailColorPicker.jsx